import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["circle", "centerText", "question", "header", "whiteOverlay"]
    static values = {
        stepKey: String,
        initialDelay: { type: Number, default: 1000 },
        questionDelay: { type: Number, default: 500 }
    }

    connect() {
        this.handleStepShown = this.handleStepShown.bind(this)
        window.addEventListener('onboarding:step-shown', this.handleStepShown)
    }

    disconnect() {
        window.removeEventListener('onboarding:step-shown', this.handleStepShown)
    }

    handleStepShown(event) {
        if (event.detail.stepKey === this.stepKeyValue) {
            this.resetAnimation()
            void this.element.offsetWidth
            this.animate()
        }
    }

    resetAnimation() {
        this.circleTarget.classList.remove("expanding-circle-expanded")
        this.circleTarget.classList.add("expanding-circle-initial")

        this.centerTextTarget.classList.remove("fade-in-visible")
        this.centerTextTarget.classList.add("fade-in-hidden")

        if (this.hasHeaderTarget) {
            this.headerTarget.classList.remove("fade-in-hidden")
            this.headerTarget.classList.add("fade-in-visible")
        }

        this.whiteOverlayTargets.forEach(overlay => {
            overlay.classList.remove("opacity-100")
            overlay.classList.add("opacity-0")
        })

        this.questionTargets.forEach(question => {
            question.classList.remove("fade-in-visible")
            question.classList.add("fade-in-hidden")
        })
    }

    animate() {
        // First, show the center text
        setTimeout(() => {
            this.centerTextTarget.classList.remove("fade-in-hidden")
            this.centerTextTarget.classList.add("fade-in-visible")
        }, this.initialDelayValue)

        // Then expand the circle and hide header
        setTimeout(() => {
            this.circleTarget.classList.remove("expanding-circle-initial")
            this.circleTarget.classList.add("expanding-circle-expanded")

            if (this.hasHeaderTarget) {
                this.headerTarget.classList.remove("fade-in-visible")
                this.headerTarget.classList.add("fade-in-hidden")
            }

            this.whiteOverlayTargets.forEach(overlay => {
                overlay.classList.remove("opacity-0")
                overlay.classList.add("opacity-100")
            })
        }, this.initialDelayValue + 600)

        // As circle expands, fade out center text
        setTimeout(() => {
            this.centerTextTarget.classList.remove("fade-in-visible")
            this.centerTextTarget.classList.add("fade-in-hidden")
        }, this.initialDelayValue + 900)

        // Fade in questions one by one
        const questionsStartDelay = this.initialDelayValue + 1200
        this.questionTargets.forEach((question, index) => {
            setTimeout(() => {
                question.classList.remove("fade-in-hidden")
                question.classList.add("fade-in-visible")
            }, questionsStartDelay + (index * this.questionDelayValue))
        })
    }
}
